var _mask, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoDataGraph(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 347,
    height: 347,
    viewBox: "0 0 347 347",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_602_3793",
    maskUnits: "userSpaceOnUse",
    x: -3.1181,
    y: -2.96568,
    width: 353.497,
    height: 353.497,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: -3.1181,
    y: -2.96568,
    width: 353.497,
    height: 353.497
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.331 169.893C347.411 264.793 272.165 343.41 177.266 345.489C82.3658 347.569 3.74847 272.323 1.66892 177.424C-0.410628 82.5238 74.835 3.90648 169.735 1.82693C264.635 -0.252619 343.252 74.9931 345.331 169.893ZM77.9792 175.751C79.1352 228.506 122.839 270.335 175.593 269.179C228.348 268.023 270.177 224.32 269.021 171.565C267.865 118.81 224.162 76.9812 171.407 78.1372C118.652 79.2932 76.8232 122.997 77.9792 175.751Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M345.331 169.893C347.411 264.793 272.165 343.41 177.266 345.489C82.3658 347.569 3.74847 272.323 1.66892 177.424C-0.410628 82.5238 74.835 3.90648 169.735 1.82693C264.635 -0.252619 343.252 74.9931 345.331 169.893ZM77.9792 175.751C79.1352 228.506 122.839 270.335 175.593 269.179C228.348 268.023 270.177 224.32 269.021 171.565C267.865 118.81 224.162 76.9812 171.407 78.1372C118.652 79.2932 76.8232 122.997 77.9792 175.751Z",
    fill: "#BBBBBB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M345.331 169.893C347.411 264.793 272.165 343.41 177.266 345.489C82.3658 347.569 3.74847 272.323 1.66892 177.424C-0.410628 82.5238 74.835 3.90648 169.735 1.82693C264.635 -0.252619 343.252 74.9931 345.331 169.893ZM77.9792 175.751C79.1352 228.506 122.839 270.335 175.593 269.179C228.348 268.023 270.177 224.32 269.021 171.565C267.865 118.81 224.162 76.9812 171.407 78.1372C118.652 79.2932 76.8232 122.997 77.9792 175.751Z",
    stroke: "#F3F5F9",
    strokeWidth: 2,
    mask: "url(#path-1-outside-1_602_3793)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDataGraph);
export default __webpack_public_path__ + "static/media/NoDataGraph.3b9391822b7376f01d06e6e3c0a2cbe3.svg";
export { ForwardRef as ReactComponent };